'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _utilsFactory = require('../utils/factory');

var _utilsFactory2 = _interopRequireDefault(_utilsFactory);

//static layout markup

var _markupMarkup_directive = require('./markup/markup_directive');

var _markupMarkup_directive2 = _interopRequireDefault(_markupMarkup_directive);

var _markupTop_nav_directive = require('./markup/top_nav_directive');

var _markupTop_nav_directive2 = _interopRequireDefault(_markupTop_nav_directive);

var _markupPlayer_controls_directive = require('./markup/player_controls_directive');

var _markupPlayer_controls_directive2 = _interopRequireDefault(_markupPlayer_controls_directive);

var _markupHeading_directive = require('./markup/heading_directive');

var _markupHeading_directive2 = _interopRequireDefault(_markupHeading_directive);

var _markupYoutube_player_directive = require('./markup/youtube_player_directive');

var _markupYoutube_player_directive2 = _interopRequireDefault(_markupYoutube_player_directive);

var _markupGenres_directive = require('./markup/genres_directive');

var _markupGenres_directive2 = _interopRequireDefault(_markupGenres_directive);

var _markupTranding_directive = require('./markup/tranding_directive');

var _markupTranding_directive2 = _interopRequireDefault(_markupTranding_directive);

var _markupFooting_directive = require('./markup/footing_directive');

var _markupFooting_directive2 = _interopRequireDefault(_markupFooting_directive);

var moduleName = 'app.directives';

_angular2['default'].module(moduleName, [])
//markup
.directive('musicHash', (0, _utilsFactory2['default'])(_markupMarkup_directive2['default'])).directive('topNav', (0, _utilsFactory2['default'])(_markupTop_nav_directive2['default'])).directive('playerControls', (0, _utilsFactory2['default'])(_markupPlayer_controls_directive2['default'])).directive('youtubePlayer', (0, _utilsFactory2['default'])(_markupYoutube_player_directive2['default'])).directive('heading', (0, _utilsFactory2['default'])(_markupHeading_directive2['default'])).directive('genres', (0, _utilsFactory2['default'])(_markupGenres_directive2['default'])).directive('tranding', (0, _utilsFactory2['default'])(_markupTranding_directive2['default'])).directive('footing', (0, _utilsFactory2['default'])(_markupFooting_directive2['default']));

exports['default'] = moduleName;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./resources/assets/js/src/modules/app.directives.js
 ** module id = 41
 ** module chunks = 0
 **/